export default __webpack_public_path__ + "static/media/road-barrier.57c47031.svg";